// src/redux/reducers/index.js
import { combineReducers } from 'redux';
import serviceTypeReducer from './serviceTypeReducer';

const rootReducer = combineReducers({
  serviceType: serviceTypeReducer,
  // other reducers can be added here
});

export default rootReducer;
